
import axios from 'axios';
var _API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRGV2ZWxvcG1lbnQgdG9rZW4iLCJwbGF0Zm9ybSI6ImRldiIsImFwcCI6IkRldmVsb3BtZW50In0.QXkohQ7lHeuS71xdcQJWa9_krUjtxFI4s1BqF1FkvW0';

const getUser = (context) => {
    
    axios
        .get(
            'https://api.agroclimate.org/v2/social/user/myinfo', {
                headers: { 
                    'x-api-key': _API_KEY,
                    'Authorization': 'Bearer ' + sessionStorage.getItem('user-jwt')
                }
            }
        )
        .then(response => {
            if (response.data.code == 'SUCCESS')
                context.commit('SET_USER', response.data.data);
        })
        .catch(e => {
            console.log(e);
        });
};

export default {
    getUser
};